import { render, staticRenderFns } from "./TipsBottomSheetLike.vue?vue&type=template&id=60117d83&"
import script from "./TipsBottomSheetLike.vue?vue&type=script&lang=js&"
export * from "./TipsBottomSheetLike.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports